import BottomSheet from 'components/BottomSheet';
import Icon from 'components/Icon';
import React from 'react';
import Form from './Form';

type AppProps = {
  open: boolean;
  closeModal: () => any;
  initial_template?: number;
  initial_recipient?: string;
  initial_job_doc?: string;
};

const CreateEmail: React.FC<AppProps> = ({
  open,
  closeModal,
  initial_template,
  initial_recipient,
  initial_job_doc,
}) => {
  return (
    <BottomSheet open={open} maxWidth="max-w-2xl">
      <div className="pb-4">
        <div className="flex justify-between">
          <div className="page-heading">Create New Email</div>
          <div>
            <Icon
              name="close"
              size={32}
              onClick={closeModal}
              className="cursor-pointer"
            />
          </div>
        </div>
      </div>
      <Form
        onSuccess={closeModal}
        initial_template={initial_template}
        initial_recipient={initial_recipient}
        initial_job_doc={initial_job_doc}
      />
    </BottomSheet>
  );
};

export default CreateEmail;
